const STICKY_SCROLLUP_CLASS = 'component-customeraccompaniementmesh--sticky-scrollup';
export default class StickyCustomerHelp {
  constructor(id) {
    this.lastScrollY = window.scrollY;
    try {
      this.componentContainer = document.getElementById(id);
    } catch (error) {
      throw `Error : ${error}`;
    }
  }
  init() {
    this.trackScrollDirection();
  }
  trackScrollDirection() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }
  handleScroll() {
    const currentScrollY = window.scrollY;
    if (currentScrollY < this.lastScrollY) {
      this.addScrollUpClass();
    } else {
      this.removeScrollUpClass();
    }
    this.lastScrollY = currentScrollY;
  }
  addScrollUpClass() {
    if (this.componentContainer) {
      this.componentContainer.classList.add(STICKY_SCROLLUP_CLASS);
    }
  }
  removeScrollUpClass() {
    if (this.componentContainer) {
      this.componentContainer.classList.remove(STICKY_SCROLLUP_CLASS);
    }
  }
}